import script from "./ReporteRecaudacion.vue?vue&type=script&setup=true&lang=js"
export * from "./ReporteRecaudacion.vue?vue&type=script&setup=true&lang=js"

import "./ReporteRecaudacion.vue?vue&type=style&index=0&id=38652e82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38652e82"]])

export default __exports__